import React from 'react';
import { Star, Quote, ArrowRight } from 'lucide-react';
import { motion } from 'framer-motion';
export function Reviews() {
  const reviews = [{
    name: 'Matthew A.',
    text: "I've been using Completely Electrical since Brodie started up and they always do quality job",
    rating: 5,
    initials: 'MA',
    color: 'bg-blue-100 text-blue-700'
  }, {
    name: 'Jacob P.',
    text: 'Brodie and his team are fantastic. On time and very neat work. Highly recommend',
    rating: 5,
    initials: 'JP',
    color: 'bg-emerald-100 text-emerald-700'
  }, {
    name: 'Nancy V.',
    text: 'Brodie and the team were professional, friendly, and actually showed up on time.',
    rating: 5,
    initials: 'NV',
    color: 'bg-purple-100 text-purple-700'
  }, {
    name: 'Penny W.',
    text: 'Highly recommended! Good pricing, great communication and lovely team that were so good to work with.',
    rating: 5,
    initials: 'PW',
    color: 'bg-amber-100 text-amber-700'
  }, {
    name: 'Simon',
    text: 'Amazing service, excellent communication, and a great price.',
    rating: 5,
    initials: 'S',
    color: 'bg-rose-100 text-rose-700'
  }];
  return <section className="py-20 lg:py-28 bg-cream" id="reviews" data-id="element-377">
      <div className="max-w-7xl mx-auto px-4" data-id="element-378">
        <div className="flex flex-col md:flex-row justify-between items-end mb-14 gap-8" data-id="element-379">
          <div className="max-w-2xl" data-id="element-380">
            <span className="text-accent font-bold tracking-wider uppercase text-sm mb-3 block" data-id="element-381">
              The Proof
            </span>
            <h2 className="text-4xl md:text-5xl font-heading font-extrabold text-navy mb-6 tracking-tighter" data-id="element-382">
              What Perth Locals Say About Us
            </h2>

            <div className="flex items-center gap-4 bg-white px-6 py-4 rounded-xl shadow-sm border border-gray-100 inline-flex" data-id="element-383">
              <div className="flex flex-col items-center justify-center border-r border-gray-100 pr-4" data-id="element-384">
                <span className="text-3xl font-heading font-extrabold text-navy leading-none" data-id="element-385">
                  5.0
                </span>
                <span className="text-[10px] font-bold text-gray-400 mt-0.5" data-id="element-386">
                  441 reviews
                </span>
              </div>
              <div className="flex flex-col gap-1" data-id="element-387">
                <div className="flex text-yellow-400" data-id="element-388">
                  {[1, 2, 3, 4, 5].map(star => <Star key={star} className="w-5 h-5 fill-current" data-id="element-389" />)}
                </div>
                <span className="text-sm font-bold text-slate flex items-center gap-1" data-id="element-390">
                  <span className="inline-flex items-center justify-center w-5 h-5 rounded-full bg-white shadow-sm border border-gray-100 font-extrabold text-[12px]" data-id="element-391">
                    <span className="bg-clip-text text-transparent bg-gradient-to-br from-blue-500 via-red-500 to-yellow-500" data-id="element-392">
                      G
                    </span>
                  </span>
                  Based on Google Reviews
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* Stat Strip */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12 bg-white rounded-2xl shadow-sm border border-gray-100 p-6" data-id="element-393">
          {[{
          num: '441',
          label: 'Reviews'
        }, {
          num: '5.0',
          label: 'Average rating'
        }, {
          num: '0',
          label: 'Complaints'
        }, {
          num: '100%',
          label: 'Recommend'
        }].map((stat, i) => <div key={i} className="text-center px-2 md:border-r last:border-r-0 border-gray-100" data-id="element-394">
              <div className="text-3xl md:text-4xl font-heading font-extrabold text-accent mb-1 leading-none" data-id="element-395">
                {stat.num}
              </div>
              <div className="text-xs md:text-sm font-bold text-navy uppercase tracking-wider" data-id="element-396">
                {stat.label}
              </div>
            </div>)}
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-397">
          {reviews.map((review, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-white p-7 rounded-2xl shadow-sm border-l-4 border-accent border-y border-r border-y-gray-100 border-r-gray-100 relative flex flex-col h-full" data-id="element-398">
              <Quote className="w-8 h-8 text-gray-100 absolute top-6 right-6" data-id="element-399" />

              <div className="flex text-yellow-400 mb-5" data-id="element-400">
                {[...Array(review.rating)].map((_, i) => <Star key={i} className="w-4 h-4 fill-current" data-id="element-401" />)}
              </div>

              <p className="text-slate mb-7 relative z-10 leading-relaxed flex-grow text-sm" data-id="element-402">
                "{review.text}"
              </p>

              <div className="flex items-center gap-3 border-t border-gray-50 pt-5 mt-auto" data-id="element-403">
                <div className={`w-10 h-10 rounded-full flex items-center justify-center font-bold text-sm ${review.color}`} data-id="element-404">
                  {review.initials}
                </div>
                <div data-id="element-405">
                  <h4 className="font-extrabold text-navy text-sm" data-id="element-406">
                    {review.name}
                  </h4>
                  <span className="text-xs text-gray-500 font-medium" data-id="element-407">
                    Recent Google Review
                  </span>
                </div>
              </div>
            </motion.div>)}

          {/* 6th Card - CTA */}
          <motion.a href="https://www.google.com/search?q=completely+electrical+huntingdale+reviews" target="_blank" rel="noopener noreferrer" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="bg-navy p-7 rounded-2xl shadow-lg relative flex flex-col items-center justify-center text-center group hover:bg-navy-600 transition-colors cursor-pointer h-full min-h-[250px]" data-id="element-408">
            <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center mb-5 shadow-md" data-id="element-409">
              <Star className="w-8 h-8 text-accent fill-accent" data-id="element-410" />
            </div>
            <h3 className="text-2xl font-heading font-extrabold text-white mb-3" data-id="element-411">
              Read All 441 Reviews
            </h3>
            <p className="text-gray-200 mb-6 text-sm" data-id="element-412">
              See why Perth's south side rates us 5 stars on Google.
            </p>
            <div className="flex items-center gap-2 text-accent font-extrabold group-hover:text-white transition-colors" data-id="element-413">
              View on Google
              <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-414" />
            </div>
          </motion.a>
        </div>
      </div>
    </section>;
}